import {memo} from "react";
import {NodeProps} from "@xyflow/react";
import {Metric, TreeNode} from "@/types";
import {BasicCardNode, get_color, render_line} from "@/pages/mindmap/CarNodes/BasicCardNode.tsx";
import {formatCompactNumber, formatPercentage} from "@/utils/format.ts";

export const PlanNode = memo(({data}: NodeProps) => {
    const node: TreeNode = data.node as any;
    const datas: Record<string, Metric> = node.metrics_map || {};


    const render_platform_line = (platform: string, data_type: string) => {
        return <div>
            <span>{`${platform.toUpperCase()} MTD ${data_type.toUpperCase()}  `}</span>
            <span style={get_color(`${data_type}_amt_mtd_${platform}`, datas)}>
                {formatCompactNumber(datas[`${data_type}_amt_mtd_${platform}`]?.value, 1, 'M')}
            </span>
            <span>, Gap </span>
            <span style={get_color(`${data_type}_amt_mtd_gap_${platform}`, datas)}>
                {formatCompactNumber(datas[`${data_type}_amt_mtd_gap_${platform}`]?.value, 1, 'M')}
            </span>
            <span>, Achi </span>
            <span style={get_color(`${data_type}_amt_mtd_achi_${platform}`, datas)}>
                {formatPercentage(datas[`${data_type}_amt_mtd_achi_${platform}`]?.value, 1)}
            </span>
            <span>, Vol Gro </span>
            <span style={get_color(`${data_type}_amt_mtd_vol_growth_${platform}`, datas)}>
                {formatPercentage(datas[`${data_type}_amt_mtd_vol_growth_${platform}`]?.value, 1)}
            </span>


        </div>
    }

    const render_top = (is_top_ka: boolean = true) => {
        const prefix = is_top_ka ? 'nm_top_100' : 'nm_gp';
        return <>
            {render_line('ims', 'mtd', datas, true)}
            <br/>
            <div>
                <span style={get_color(`${prefix}_green`, datas)}>{datas[`${prefix}_green`].value || 0}</span>
                &nbsp;hospitals reached ≥ 100%
            </div>
            <div>
                <span style={get_color(`${prefix}_black`, datas)}>{datas[`${prefix}_black`].value || 0}</span>
                &nbsp;hospitals reached 95-99%
            </div>
            <div>
                <span style={get_color(`${prefix}_red`, datas)}>{datas[`${prefix}_red`].value || 0}</span>
                &nbsp;hospitals reached ≤ 95%
            </div>
            <br/>
        </>
    }

    const renderDescription = () => {

        if (node.id === 'top100ka') {
            return <>
                {render_top()}
                {render_platform_line('mip', 'ims')}
                {render_platform_line('ae', 'ims')}
                {render_platform_line('wch', 'ims')}
                {render_platform_line('bio', 'ims')}
            </>
        } else if (node.id.endsWith("growth-plan")) {
            return <>{render_top(false)}</>
        } else {
            return <>未知的id类型{node.id}</>
        }
    }


    return <BasicCardNode node={node} showChart={true} data={data}>
        {renderDescription()}
    </BasicCardNode>
})